import {StateProvider} from "@uirouter/angularjs";
import {UserConfigProvider} from "../../types/UserConfig";
import {ClientDashboardService} from "../client/service/ClientDashboardService";
import {ClientDashboardModel} from "../client/models/ClientDashboardModel";

export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {

    const pageTitle = "Implied Volatility";

    if (userConfigProvider.config.client != null) {
        $stateProvider.state("home", {
            url: "/?view",
            component: "tfClientDashboardView",
            data: {
                pageTitle
            },
            resolve: {
                model: clientModelResolver
            },
            params: {
                view: null
            }
        });
    } else {
        $stateProvider.state("home", {
            url: "/",
            templateUrl: "app/home/home.tpl.html",
            controller: "homeCtrl as home",
            data: {
                pageTitle
            }
        });
    }
}

/** @ngInject */
export const clientModelResolver = (clientDashboardService: ClientDashboardService): Promise<ClientDashboardModel> => {
    return clientDashboardService.model();
};
